import { render, staticRenderFns } from "./ReservationAppResult.vue?vue&type=template&id=13f5fe7a&scoped=true"
import script from "./ReservationAppResult.vue?vue&type=script&lang=js"
export * from "./ReservationAppResult.vue?vue&type=script&lang=js"
import style0 from "./ReservationAppResult.vue?vue&type=style&index=0&id=13f5fe7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f5fe7a",
  null
  
)

export default component.exports